import { ConfigObj } from '../utils/'

const defaultOpts = {
  message: 'Nothing to show'
}

export default class PricingCalculatorPage {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
    this.$pricingWarningMerchant = $el.querySelector('.ps-pricing-display-warning-merchant')
    this.$pricingWarningCto = $el.querySelector('.ps-pricing-display-warning-cto')
    this.$pricingContainer = $el.querySelector('.ps-pricing-container')
    this.$customisedQuote = $el.querySelector('.ps-customised-quote')
    this.$pricingButton = $el.querySelector('.ps-pricing-button')
    this.$transactionInputs = $el.querySelectorAll('input[type="text"]')
    this.$merchantSelect = $el.querySelector('select[name="Merchant"]')
  }

  init() {
    this.$pricingButton.addEventListener('click', this.showMerchantWarning.bind(this))
    this.$pricingButton.addEventListener('click', this.showCtoWarning.bind(this))
    this.$pricingButton.addEventListener('click', this.showPricingBreakdown.bind(this))
    this.$transactionInputs.forEach((transactionInput) => transactionInput.addEventListener('keypress', this.restrictTransactionKeyInput.bind(this)))
    this.$transactionInputs.forEach((transactionInput) => transactionInput.addEventListener('blur', this.prependCurrencySymbol.bind(this)))
    this.$transactionInputs[0].addEventListener('blur', this.showPricingBreakdown.bind(this))
    this.$merchantSelect.addEventListener('change', this.showMerchantWarning.bind(this))
  }

  prependCurrencySymbol(event) {
    let textboxValue = event.target.value

    textboxValue = textboxValue.replace('£', '')

    event.target.value = '£' + textboxValue
  }

  restrictTransactionKeyInput(event) {
    // Check both the which property (modern browsers) and the keyCode property (older browsers)
    const charCode = event.which || event.keyCode;

    // Convert the character code into a string representation of the pressed key
    const char = String.fromCharCode(charCode);

    // Regex pattern for numbers and a decimal point
    const regex = /^[\d.]+$/;

    if (!regex.test(char)) {
      event.preventDefault();
    }
  }

  showMerchantWarning() {
    const isMccSelected = this.$merchantSelect.value.length > 1

    if (!isMccSelected) {
      this.$pricingWarningMerchant.style.display = 'block'
    } else {
      this.$pricingWarningMerchant.style.display = 'none'
    }
  }

  showCtoWarning() {
    const ctoValue = this.$transactionInputs[0].value

    if (ctoValue > 0) {
      this.$pricingWarningCto.style.display = 'none'
    } else {
      this.$pricingWarningCto.style.display = 'table-cell'
    }
  }

  showPricingBreakdown() {
    const textboxValue = this.$transactionInputs[0].value.replace('£', '')
    const isMccSelected = this.$merchantSelect.value.length > 1

    // Here to make sure user at least puts in some numerical value
    if (textboxValue > 0) {
      this.$pricingWarningCto.style.display = 'none'
    }

    if (textboxValue > 0 && isMccSelected) {
      this.$pricingContainer.style.display = 'block'
    }

    if (textboxValue < 150000) {
      this.$customisedQuote.style.display = 'none'
    } else {
      this.$customisedQuote.style.display = 'block'
    }
  }
}



// WEBPACK FOOTER //
// ./js/modules/PricingCalculatorPage.js